import Button from '@components/Button';
import { Column } from '@components/LinearLayout';
import UnderLine from '@components/Underline';
import IllustratedText from '@composites/IllustratedText';
import { useMobileWidth, useTabletWidth } from '@utils/hooks';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { ButtonWrapper, Content, Index, List, ListItem, Title } from './styles';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import React, { useState } from 'react';

export const CollapseWrapper = ({
  children,
  sluggedEvent,
}: {
  children: React.ReactNode;
  sluggedEvent: PublicEventDetailsResponse;
}) => {
  const { t } = useTranslation();
  const [isShowing, setShowing] = useState(true);
  const theme = useTheme();
  const isMobile = useMobileWidth();

  return (
    <>
      {isMobile && (
        <ButtonWrapper>
          <Button
            title={t(isShowing ? 'less-information' : 'more-information')}
            backgroundColor={
              isShowing
                ? theme.color.mobilityGrey
                : sluggedEvent?.design?.themeColor
            }
            textColor={theme.color.white}
            borderRadius={theme.borderRadius.radius10}
            padding={isMobile ? '1.5rem 2.5rem' : '0.5rem 2.5rem'}
            width="100%"
            onClick={() => {
              setShowing(!isShowing);
            }}
          />
        </ButtonWrapper>
      )}

      {isShowing ? children : null}
    </>
  );
};

const IllustratedList = ({
  buttonText,
  buttonURL,
  image1,
  image2,
  listItems,
  orientation,
  sluggedEvent,
  title,
}: {
  buttonText?: string;
  buttonURL?: string;
  image1: string;
  image2: string;
  listItems: string[];
  orientation: 'left' | 'right';
  sluggedEvent: PublicEventDetailsResponse;
  title: string;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMobileWidth();
  const isTablet = useTabletWidth();

  const renderContent = () => {
    return (
      <Column $gap="5rem">
        <Column $gap="2.5rem">
          <Column $gap="2.5rem">
            <Title>{title}</Title>
            <UnderLine
              width="163px"
              color={sluggedEvent?.design?.themeColor}
              justify="left"
            />
          </Column>
        </Column>

        <List>
          {listItems.map((listItem: string) => {
            return (
              <ListItem key={listItem}>
                <Index />
                <Content>{t(`${listItem}`)}</Content>
              </ListItem>
            );
          })}
        </List>

        {buttonText && buttonURL && (
          <Button
            title={buttonText}
            backgroundColor={sluggedEvent?.design?.themeColor}
            hoverBackgroundColor={theme.color.mobilityGrey}
            textColor={theme.color.white}
            borderRadius={theme.borderRadius.radius10}
            fontSize={theme.fontSize.size20}
            lineHeight={theme.lineHeight.height150}
            padding={isMobile ? '1.5rem 2.5rem' : '1.1rem 4.9rem'}
            width={isMobile ? '100%' : 'max-content'}
            onClick={() => {
              if (buttonURL?.startsWith('mailto:')) {
                window.location.href = buttonURL;
              } else {
                window.open(buttonURL, '_blank', 'noopener,noreferrer');
              }
            }}
          />
        )}
      </Column>
    );
  };

  return (
    <>
      <IllustratedText
        images={[image1, image2]}
        orientation={orientation}
        content={renderContent()}
      />
    </>
  );
};

export default IllustratedList;
